import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { BodyText } from '@calendly/ui/components/typography'
import { useDispatch, useSelector } from 'react-redux'

import { deleteDomainControl } from './actions'
import { DELETE_DOMAIN_POPUP } from './constants'
import { isPopupOpenSelector, domainForPopupSelector } from './selectors'
import { closePopup } from './slice'

export const DeleteDomainPopup = () => {
  const dispatch = useDispatch()
  const domain = useSelector(domainForPopupSelector)
  const isOpen = useSelector(isPopupOpenSelector(DELETE_DOMAIN_POPUP))

  const handleConfirm = () => {
    dispatch(deleteDomainControl(domain))
    dispatch(closePopup())
  }

  return (
    <SimplePopup
      isOpen={isOpen}
      onClose={() => dispatch(closePopup())}
      cancelLabel={I18n.t('publisher.action.cancel')}
      title={I18n.t('publisher.organization_settings.domain_control.popups.delete_title', { domain: domain?.domain })}
      confirmLabel={I18n.t('publisher.organization_settings.domain_control.delete_domain_confirmation')}
      onConfirm={handleConfirm}
      isDestructive
    >
      <BodyText>
        {I18n.t('publisher.organization_settings.domain_control.popups.delete_body', { domain: domain?.domain })}
      </BodyText>
    </SimplePopup>
  )
}
